module.exports = __webpack_public_path__ + "static/media/JYX.eb01fd5b.jpg";